import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { Toast } from 'primeng/toast';

@Component({
  selector: 'interactive-toast',
  imports: [CommonModule, Toast],
  templateUrl: './interactive-toast.component.html',
})
export class InteractiveToastComponent {
  /**
   * Optional: omit it to catch messages added with NO `key` at all — this is
   * what lets `MainLayoutComponent`'s root-provided, unkeyed outlet
   * (filing-load failures, IndexedDB write errors) reuse this component's
   * severity-based icon set instead of falling back to PrimeNG's own default
   * `<p-toast>` icons, which read visibly differently (see the git history on
   * this file for the before/after).
   */
  key = input<string>();
}
